const veloZipCodes = [
    3000, 3001, 3003, 3004, 3005, 3006, 3007, 3008, 3010, 3011, 3012, 3013, 3014, 3015, 3018, 3019, 3020, 3024, 3027, 3029, 3030, 3176,
    3203, 3205, 3204,
    3032, 3033, 3034, 3043, 3044, 3049,
    3202,
    3038,
    3047,
    3052,
    3053,
    3302,
    3322,
    3063,
    3065,
    3071, 3072,
    3112,
    3066,
    3073, 3074,
    3122,
    3084, 3095, 3097, 3098, 3144, 3145, 3145, 3147, 3172, 3173, 3174,
    3123,
    3976,
    3113,
    3110
];

export default veloZipCodes
